import type { CandleStudy } from '../../lib/candleStudy';
import { Badge } from '../ui/Badge';
import { Panel } from '../ui/Panel';

export function CandleStudyPanel({ study }: { study: CandleStudy }): React.JSX.Element {
  const tone = study.direction === 'bullish' ? 'positive' : study.direction === 'bearish' ? 'negative' : 'neutral';
  return (
    <Panel
      title="Active candle question set"
      description="Candle anatomy is descriptive evidence and never a standalone long or short signal."
      action={<Badge tone={tone}>{study.shape.replace('-', ' ')}</Badge>}
    >
      <dl className="info-list">
        <div className="info-row"><dt>Direction</dt><dd>{study.direction}</dd></div>
        <div className="info-row"><dt>Candle maturity</dt><dd>{study.maturity.toFixed(1)}%</dd></div>
        <div className="info-row"><dt>Body / range</dt><dd>{study.bodyPercent.toFixed(1)}%</dd></div>
        <div className="info-row"><dt>Upper wick / range</dt><dd>{study.upperWickPercent.toFixed(1)}%</dd></div>
        <div className="info-row"><dt>Lower wick / range</dt><dd>{study.lowerWickPercent.toFixed(1)}%</dd></div>
        <div className="info-row"><dt>Close location</dt><dd>{study.closeLocationPercent.toFixed(1)}%</dd></div>
        <div className="info-row"><dt>Range from open</dt><dd>{study.rangePercent.toFixed(2)}%</dd></div>
        <div className="info-row"><dt>Raw accumulated volume</dt><dd>{study.rawVolumeRatio.toFixed(2)}×</dd></div>
        <div className="info-row"><dt>Time-normalized volume pace</dt><dd>{study.volumeRatio.toFixed(2)}×</dd></div>
      </dl>
      <div className="narrative-list">
        {study.observations.map((item, index) => <div className="narrative-item" key={`${index}-${item.slice(0, 18)}`}>{item}</div>)}
      </div>
    </Panel>
  );
}
